document.addEventListener("DOMContentLoaded", function () {
  const swiperContainers = document.querySelectorAll(".swiper-container");

  swiperContainers.forEach(function (container) {
    // コンテナごとにSwiperを初期化
    new Swiper(container, {
      arrows: false,
      centerMode: true,
      autoplay: true,
      effect: "fade",
      loop: true,
      speed: 1600,
      pagination: {
        el: container.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: container.querySelector(".swiper-button-next"),
        prevEl: container.querySelector(".swiper-button-prev"),
      },
      scrollbar: {
        el: container.querySelector(".swiper-scrollbar"),
      },
    });
  });
});
